import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Notepad = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
    viewBox="0 0 20 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke={props.color || theme.palette.grey600}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.0042 23H2.9962c-1.102 0-1.996-.894-1.996-1.996V4.996c0-1.102.894-1.996 1.996-1.996h14.008c1.103 0 1.996.894 1.996 1.996v16.008c0 1.102-.893 1.996-1.996 1.996zM5.0003 1v4M10.0003 1v4M10.0003 1v4M15.0003 1v4M5.0003 17h10M5.0003 11h10" />
    </g>
  </svg>
);
